<script>
import SelectTerritory from './_components/select-territory.vue'
import InputDate from './_components/input-date.vue'
import Datatable from './_components/datatable.vue'
import moment from "moment/moment";

export default {
  components: {
    SelectTerritory,
    InputDate,
    Datatable,
  },
  data() {
    return {
      title: "Monitoring Salesman",
      date: null,
      operatingUnits: [],
      territoryIDs: [],
      status: {
        options: [
          {
            text: 'All',
            value: 0
          },
          {
            text: 'Yes',
            value: 1
          },
          {
            text: 'No',
            value: 2
          }
        ],
        selected: {
          text: 'All',
          value: 0
        },
      }
    }
  },
  methods: {
    async onClickButtonSearch(){
      if (!this.date){
        this.$vs.notify({
          title: "Error",
          text: "Please select date",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      await this.$refs.datatable.setDate(this.date);
      await this.$refs.datatable.setTerritoryIDs(this.territoryIDs);
      await this.$refs.datatable.setStatus(this.status.selected.value);
      await this.$refs.datatable.getData();
    },
    setTerritory(selected) {
      this.territoryIDs = selected.map(item => item.id)
    },
  },
  filters:{
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
  },
  watch: {
    territories(val) {
      if (val.length === 0) return
    }
  },
  mounted() {
    let params = {
      operating_unit_ids : [],
      length: 0,
    }
    this.$refs.select_territory.getData(params);
  }
}
</script>

<template>
  <vx-card :title="title">
    <div class="vx-row mb-6 mt-4">
      <div class="vx-col w-1/2">
        <select-territory @data="setTerritory" ref="select_territory" :operatingUnit="operatingUnits" :isMultiple="false" />

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full flex items-center">
            <span>Date</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <vs-input type="date" v-model="date" class="w-full mb-6" />
          </div>
        </div>


        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full flex items-center">
            <span>Status End Session</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <multiselect class="selectExample" v-model="status.selected" :options="status.options" label="text" />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col flex gap-2">
        <vs-button class="w-full" color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="onClickButtonSearch()">Search</vs-button>
      </div>
    </div>

    <div class="vx-row mb-2">
      <div class="core vx-col w-full mb-base">
        <datatable ref="datatable" />
      </div>
    </div>
  </vx-card>
</template>

<style>

</style>